export const PDF_SERVER_URL =
  process.env.REACT_APP_DOWNLOAD_API_URL ||
  'https://download-api.dev.lifelonglearning.ext-aws.unsw.edu.au'

export async function renderUrlToPdf(url: string): Promise<Blob> {
  const res = await fetch(`${PDF_SERVER_URL}/files/pdf-render`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ url }),
  })
  if (!res.ok) {
    throw new Error(`pdf server responded with ${res.status}`)
  }
  return res.blob()
}
